import { useCallback } from 'react';

declare global {
  interface Window {
    Razorpay: any;
  }
}

interface RazorpaySubscriptionResult {
  razorpay_subscription_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

interface OpenSubscriptionCheckoutParams {
  subscription_id: string; // Razorpay subscription ID
  key_id: string;
  name?: string;
  description?: string;
  prefill?: {
    name?: string;
    email?: string;
    contact?: string;
  };
}

export const useRazorpay = () => {
  const openCheckout = useCallback(
    (params: OpenSubscriptionCheckoutParams): Promise<RazorpaySubscriptionResult> => {
      return new Promise((resolve, reject) => {
        if (!window.Razorpay) {
          reject(new Error('Razorpay SDK not loaded. Please refresh the page.'));
          return;
        }

        const options = {
          key: params.key_id,
          subscription_id: params.subscription_id,
          name: params.name || 'BaseQueue',
          description: params.description || 'Subscription Payment',
          handler: (response: RazorpaySubscriptionResult) => {
            resolve(response);
          },
          prefill: params.prefill || {},
          theme: {
            color: '#076FF7',
          },
          modal: {
            ondismiss: () => {
              reject(new Error('Payment cancelled by user'));
            },
          },
        };

        const rzp = new window.Razorpay(options);

        rzp.on('payment.failed', (response: any) => {
          reject(
            new Error(
              response?.error?.description || 'Payment failed. Please try again.'
            )
          );
        });

        rzp.open();
      });
    },
    []
  );

  return { openCheckout };
};

export default useRazorpay;
